const YOUTUBE_HOST = 'youtube.com';
const YOUTUBE_SHORT_HOST = 'youtu.be';

// 지원하는 Youtube URL 패턴
// www.youtube.com/watch?v={videoId}
// m.youtube.com/watch?v={videoId}
// youtu.be/{videoId}
// youtube.com/shorts/{videoId}
// youtube.com/v/{videoId}
// youtube.com/live/{videoId}
function extractVideoId(url: URL): string | null {
  const { hostname, pathname, searchParams } = url;
  const pathSegments = pathname.split('/').filter(Boolean);

  if (hostname === YOUTUBE_SHORT_HOST) {
    return pathSegments[0] ?? null;
  }

  if (hostname !== YOUTUBE_HOST && !hostname.endsWith(`.${YOUTUBE_HOST}`)) {
    return null;
  }

  if (pathSegments.length === 1 && pathSegments[0] === 'watch') {
    return searchParams.get('v') || null;
  }

  const [type, videoId] = pathSegments;
  return ['v', 'shorts', 'embed', 'live'].includes(type)
    ? videoId ?? null
    : null;
}

export function parseYoutubeUrl(url: string) {
  let parsedUrl: URL | null = null;
  try {
    const trimmedUrl = url.trim();
    const normalizedUrl = /^https?:\/\//i.test(trimmedUrl)
      ? trimmedUrl
      : `https://${trimmedUrl}`;
    parsedUrl = new URL(normalizedUrl);
  } catch {
    // 유튜브가 아닌/잘못된 URL은 호출자가 일반 iframe 또는 오류 fallback으로 처리합니다.
  }

  const queryParams = parsedUrl?.searchParams ?? new URLSearchParams();
  const videoId = parsedUrl == null ? null : extractVideoId(parsedUrl);

  const autoPlay = ['1', 'true'].includes(queryParams.get('autoplay') ?? '');
  const zepScriptAutoplay = ['1', 'true'].includes(
    queryParams.get('zepScriptAutoplay') ?? '',
  );
  const loop = ['1', 'true'].includes(queryParams.get('loop') ?? '');
  const mute = ['1', 'true'].includes(queryParams.get('muted') ?? '');
  const _t = queryParams.get('t');
  const start = _t != null ? parseInt(_t) : undefined;

  return {
    videoId,
    autoPlay,
    zepScriptAutoplay,
    loop,
    mute,
    start,
  };
}

/**
 * Prefer the ID parsed from the URL because legacy game-server blocks can send
 * an empty or route-name `youtubeId` (for example, `live`).
 */
export function resolveYoutubeVideoId(
  youtubeId: string | null | undefined,
  url: string | null | undefined,
) {
  return (
    (url != null ? parseYoutubeUrl(url).videoId : null) ??
    (youtubeId?.trim() || null)
  );
}
